import React, { useState } from "react";
import {
  Link,
  Outlet,
  useNavigate,
  useLocation
} from "react-router-dom";

import {
  Home,
  LogOut,
  Menu,
  Pencil,
  QrCode,
  Store
} from "lucide-react";

export default function OwnerLayout() {

  const navigate = useNavigate();
  const location = useLocation();

  const [menuOpen, setMenuOpen] =
    useState(false);

  /*
  TOGGLE SIDEBAR
  */

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  /*
  LOGOUT
  */

  const logout = () => {

    localStorage.removeItem(
      "ownerToken"
    );

    localStorage.removeItem(
      "userRole"
    );

    localStorage.removeItem(
      "restaurantId"
    );

    navigate("/owner-login");

  };

  const isActive = (path) =>
    location.pathname === path;

  return (

    <div style={styles.container}>

      {/* HEADER */}

      <div style={styles.header}>

        <button
          style={styles.menuButton}
          onClick={toggleMenu}
        >
          ☰
        </button>
      <div style={{ marginLeft: "10px" }}>
        <h3 style={{ margin: 0 }}>
          Hi, Restaurant Owner 👋
        </h3>

        <p style={{ margin: 0, fontSize: "12px", opacity: 0.8 }}>
          Welcome back to your dashboard
        </p>
        </div>

      </div>

      {/* OVERLAY */}

      {menuOpen && (
        <div
          style={styles.overlay}
          onClick={() =>
            setMenuOpen(false)
          }
        />
      )}

      {/* SIDEBAR */}

      <div
        style={{
          ...styles.sidebar,
          left:
            menuOpen
              ? "0"
              : "-300px"
        }}
      >

        {/* LOGO */}

        <div style={styles.logoBox}>
          <h2 style={styles.logo}>
            🍽 Restaurant
          </h2>
          <p style={styles.subtitle}>
            Owner Panel
          </p>
        </div>

        {/* MENU */}

        <Link
          style={{
            ...styles.link,
            ...(isActive("/owner/dashboard")
              ? styles.activeLink
              : {})
          }}
          to="/owner/dashboard"
          onClick={() =>
            setMenuOpen(false)
          }
        >
          <Home style={styles.icon} />
          Dashboard
        </Link>

        <Link
          style={{
            ...styles.link,
            ...(isActive("/owner/menu")
              ? styles.activeLink
              : {})
          }}
          to="/owner/menu"
          onClick={() =>
            setMenuOpen(false)
          }
        >
          <Menu style={styles.icon} />
          Manage Menu
        </Link>

        <Link
          style={{
            ...styles.link,
            ...(isActive("/owner/edit")
              ? styles.activeLink
              : {})
          }}
          to="/owner/edit"
          onClick={() =>
            setMenuOpen(false)
          }
        >
          <Pencil style={styles.icon} />
          Edit Restaurant
        </Link>

        <Link
          style={{
            ...styles.link,
            ...(isActive("/owner/qr")
              ? styles.activeLink
              : {})
          }}
          to="/owner/qr"
          onClick={() =>
            setMenuOpen(false)
          }
        >
          <QrCode style={styles.icon} />
          QR Code
        </Link>

        <Link
          style={{
            ...styles.link,
            ...(isActive("/owner/upgrade")
              ? styles.activeLink
              : {})
          }}
          to="/owner/upgrade"
          onClick={() =>
            setMenuOpen(false)
          }
        >
          <Store style={styles.icon} />
          Upgrade Plan
        </Link>

        {/* LOGOUT */}

        <button
          style={styles.logout}
          onClick={logout}
        >
          <LogOut
            size={18}
            style={{ marginRight: 8 }}
          />
          Logout
        </button>

      </div>

      {/* CONTENT */}

      <div style={styles.content}>
        <Outlet />
      </div>

    </div>

  );

}

const styles = {

  sidebar: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "270px",
    height: "100vh",
    background: "linear-gradient(180deg, #ffffff, #fff7f2)",
    padding: "22px 18px",
    boxShadow: "4px 0 25px rgba(0,0,0,0.08)",
    zIndex: 1000,
    transition: "0.35s ease",
    display: "flex",
    flexDirection: "column",
    borderTopRightRadius: "28px",
    borderBottomRightRadius: "28px",
    overflow: "hidden",
  },

  logoBox: {
    paddingBottom: "24px",
    borderBottom: "1px solid #f1f1f1",
    marginBottom: "4px",
  },

  logo: {
    margin: 0,
    fontSize: "26px",
    fontWeight: "800",
    color: "#ff8d13",
    letterSpacing: "0.5px",
  },

  subtitle: {
    marginTop: "6px",
    fontSize: "13px",
    color: "#777",
    fontWeight: "500",
  },

  link: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    textDecoration: "none",
    color: "#333",
    padding: "15px 16px",
    borderRadius: "18px",
    marginBottom: "12px",
    fontSize: "15px",
    fontWeight: "600",
    transition: "all 0.3s ease",
    background: "transparent",
  },

  activeLink: {
    background: "linear-gradient(135deg, #ff6b00, #ff914d)",
    color: "#fff",
    boxShadow: "0 6px 16px rgba(255,107,0,0.25)",
  },

  icon: {
    width: "20px",
    height: "20px",
  },

  logout: {
    marginTop: "auto",
    marginBottom: "50px",
    border: "none",
    background: "#fff1f1",
    color: "#dc2626",
    padding: "15px",
    borderRadius: "18px",
    fontSize: "15px",
    fontWeight: "700",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "0.3s ease",
    boxShadow: "0 4px 10px rgba(220,38,38,0.08)",
  },



  container: {
    fontFamily: "Segoe UI, sans-serif"
  },

  header: {
    height: "60px",
    background:
      "#fff",
    color: "#181818",
    display: "flex",
    alignItems: "center",
    padding: "0 15px",
    fontWeight: "600",
    boxShadow:
      "0 2px 6px rgba(0,0,0,0.1)"
  },

  menuButton: {
    fontSize: "24px",
    background: "transparent",
    border: "none",
    color: "#161616",
    cursor: "pointer",
    marginRight: "10px"
  },

  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background:
      "rgba(0,0,0,0.4)",
    zIndex: 998
  },



  content: {
    padding: "0"
  }

};